module.exports = __webpack_public_path__ + "img/Ostéopathe.177df6eb.png";